import { helper } from '@ember/component/helper';

export default helper(function formatBoolean(boolean) {
  if (!boolean) {
    return '';
  }

  return boolean ? 'yes' : 'no';
});
